import { TextField, FormControl, InputLabel, OutlinedInput, InputAdornment, Tooltip } from "@mui/material";
import {useRef, useEffect} from 'react';
export default function FormStaff(props) {
    const formatNumber = (num) => {
        if (!num) return '';
        // Remove any existing commas and non-numeric characters except decimal point
        const cleanNum = num.toString().replace(/[^\d.-]/g, '');
        // Format with commas
        return cleanNum.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        // Remove commas before saving to state
        const cleanValue = value.replace(/,/g, '');
        // Convert empty string to 0 for numeric fields
        const finalValue = cleanValue === '' ? 0 : cleanValue;
        props.setSelectedFinancial({ ...props.selectedFinancial, [name]: finalValue });
    }

    const onChecked = (e) => {
        const { name, checked } = e.target;
        props.setSelectedFinancial({ ...props.selectedFinancial, [name]: checked });
    }
      // Create ref for first input
      const firstInputRef = useRef(null);

      // Focus on first input when component mounts
      useEffect(() => {
          if (firstInputRef.current) {
              firstInputRef.current.focus();
          }
      }, []); // Empty dependency array means this runs once when component mounts
  

    return (
        <>
            <div className="formRow">
                <div className="formGroup">
                    <Tooltip title="Field staff is specifically defined as people who spend more than 50% of their time in the field." arrow placement="top">
                        <TextField 
                            className="formControl" 
                            label="Field Count" 
                            onChange={onChange} 
                            value={formatNumber(props.selectedFinancial.staffFieldCount)} 
                            name='staffFieldCount' 
                            inputRef={firstInputRef}
                        />
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Office staff is specifically defined as people who spend more than 50% of their time in the office." arrow placement="top">
                        <TextField 
                            className="formControl" 
                            label="Office Count" 
                            onChange={onChange} 
                            value={formatNumber(props.selectedFinancial.staffOfficeCount)} 
                            name='staffOfficeCount' 
                        />
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Divide total revenue for the financial period being reported by the total number of field manhours invoiced for the period. " arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Revenue / Man Hour</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.staffRevenuePerManhour)}
                                onChange={onChange}
                                name='staffRevenuePerManhour'
                                label="Revenue / Man Hour"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
            </div>
            <div className="formRow">
                <div className="formGroup">
                    <Tooltip title="Divide material cost per manhour by the total number of field manhours invoiced for the period." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Material / Man Hour</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.staffMaterialPerManhour)}
                                onChange={onChange}
                                name='staffMaterialPerManhour'
                                label="Material / Man Hour"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Total dollar value of bids won divided by the total dollar value of all bids during the period. Note enter as decimal value, i.e. 0.79." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Estimating Hit Rate by Dollar Volume</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">%</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.staffEstimatingDollar)}
                                onChange={onChange}
                                name='staffEstimatingDollar'
                                label="Estimating Hit Rate by Dollar Volume"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Total count of bids won divided by total count of all bids during the period. Note enter as decimal value, i.e. 0.79." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Estimating Hit Rate by Bid Count</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">%</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.staffEstimatingCount)}
                                onChange={onChange}
                                name='staffEstimatingCount'
                                label="Estimate Hit Rate by Bid Count"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
            </div>
            <div className="formRow">
                <div className="formGroup">
                    <Tooltip title="Enter actual EMR for Company." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>EMR</InputLabel>
                            <OutlinedInput
                                value={formatNumber(props.selectedFinancial.staffEMR)}
                                onChange={onChange}
                                name='staffEMR'
                                label="EMR"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Divide total workers compensation cost by total number of field man hours performed." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Workers Comp</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.staffWorkersComp)}
                                onChange={onChange}
                                name='staffWorkersComp'
                                label="Workers Comp"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">

                </div>
            </div>







        </>
    );
}